import { defineRouter } from '#q-app'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'

export default defineRouter(function (/* { store, ssrContext } */) {
  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createWebHistory(import.meta.env.VUE_ROUTER_BASE)
  })

  Router.afterEach((to) => {
    setTimeout(() => {
      window._paq.push(['setCustomUrl', to.fullPath])
      window._paq.push(['setDocumentTitle', document.title])
      window._paq.push(['trackPageView'])
    }, 500)
  })

  return Router
})
